module.exports = __webpack_public_path__ + "media/images/og-922805a81f7a5477c55cd61de3dd181c.jpg";